// This file is AUTOGENERATED, do not edit it manually!!!

export const filters = {
    Activity_Text: 'Activiteit',
    ActivityActualBilling: 'Activiteit factureerbaar',
    ActivityActualCompletionDateCondition_Text: 'Activiteit daadwerkelijke voltooiingsdatum',
    ActivityActualCost: 'Activiteit werkelijke kosten',
    ActivityActualGreaterThanEstimated_Text: 'Onderschatte activiteiten',
    ActivityActualHours: 'Activiteit werkelijke uren',
    ActivityActualLaborBilling: 'Activiteit werkelijke factureerbare uren',
    ActivityActualLaborCost: 'Activiteit werkelijke loonkosten',
    ActivityBillableHours: 'Activiteit factureerbare uren',
    ActivityBilled: 'Activiteit gefactureerd',
    ActivityBilledLabor: 'Activiteit gefactureerde uren',
    ActivityBilledPercentage: 'Activiteit gefactureerd, %',
    ActivityBudgetVariance: 'Activiteit budgetafwijking',
    ActivityCreationDateCondition_Text: 'Activiteit aanmaakdatum',
    ActivityCreator_Text: 'Activiteit makers',
    ActivityCreatorCondition_Empty_Text: 'Systeem',
    ActivityCreatorCondition_Text: 'Activiteit maker',
    ActivityCustomFieldCondition_Text: 'Activiteit aangepaste velden',
    ActivityDuration: 'Activiteit duur',
    ActivityEACBillableExpenses: 'Activiteit EAC factureerbare kosten',
    ActivityEACBilling: 'Activiteit EAC factureerbare',
    ActivityEACCost: 'Activiteit EAC kosten',
    ActivityEACExpenses: 'Activiteit EAC kosten',
    ActivityEACLaborBilling: 'Activiteit EAC factureerbare uren',
    ActivityEACLaborCost: 'Activiteit EAC loonkosten',
    ActivityEACNonBillableExpenses: 'Activiteit EAC niet-factureerbare kosten',
    ActivityEndDateCondition_Text: 'Activiteit einddatum',
    ActivityEstimatedExpensesAmount: 'Activiteit ETC kosten',
    ActivityEstimatedExpensesBillableAmount: 'Activiteit ETC factureerbare kosten',
    ActivityEstimatedExpensesNonBillableAmount: 'Activiteit ETC niet-factureerbare kosten',
    ActivityEstimatedHours: 'Activiteit geschatte uren',
    ActivityETCBilling: 'Activiteit ETC factureerbare',
    ActivityETCCost: 'Activiteit ETC kosten',
    ActivityETCLaborBilling: 'Activiteit ETC factureerbare uren',
    ActivityETCLaborCost: 'Activiteit ETC loonkosten',
    ActivityExpectedProfit: 'Activiteit verwachte winst',
    ActivityExpectedProfitPercentage: 'Activiteit verwachte winst, %',
    ActivityExpensesAmount: 'Activiteit werkelijke kosten',
    ActivityExpensesBillableAmount: 'Activiteit werkelijke factureerbare kosten',
    ActivityExpensesBilledAmount: 'Activiteit gefactureerde kosten',
    ActivityExpensesNonBillableAmount: 'Activiteit werkelijke niet-factureerbare kosten',
    ActivityHealthCondition_Text: 'Activiteit gezondheid',
    ActivityHealthTypes: 'Activiteit gezondheid',
    ActivityIsMilestone: 'Activiteit is mijlpaal',
    ActivityNonBillableHours: 'Activiteit niet-factureerbare uren',
    ActivityProcessCondition_Text: 'Activiteit voortgang',
    ActivityProfit: 'Activiteit winst',
    ActivityProfitPercentage: 'Activiteit winst, %',
    ActivityProgress_Text: 'Activiteit voortgang',
    ActivityStartDateCondition_Text: 'Activiteit startdatum',
    ActivityStatusCondition_Text: 'Activiteit status',
    ActivityTotalBudget: 'Activiteit totaal budget',
    ActivityTypeCondition_Text: 'Activiteitstype:',
    ActivityTypes_Issue: 'Probleem',
    ActivityTypes_Request: 'Verzoek',
    ActivityTypes_Task: 'Taak',
    ActivityTypesCondition_Text: 'Activiteitstypes',
    ActualCompletionDate_Text: 'Werkelijke voltooiingsdatum',
    add_filters: 'Filters toevoegen',
    AdvancedFilterTooltipContent_Text: 'Klik hier om alle mogelijke filteropties te bekijken',
    AdvancedFilterTooltipTitle_Text: 'Geavanceerde filters',
    AllActivities_Text: 'Activiteit',
    Apply_Text: 'Toepassen',
    AssigneeCondition_Text: 'Activiteit toegewezen aan',
    AssigneeOption_Text: 'Activiteit toegewezen aan',
    AssigneeTeamCondition_Entity: 'teams',
    AssigneeUserCondition_Empty_Text: 'Geen toegewezen activiteit',
    AssigneeUserCondition_Entity: 'activiteit toegewezen aan',
    BoolCustomField_No_Text: 'Nee',
    BoolCustomField_NotSelected_Text: 'Niet geselecteerd',
    BoolCustomField_Yes_Text: 'Ja',
    BudgetAndCosts_Filters_Group: 'Budget en kosten',
    CategoriesCondition_Text: 'Categorieën',
    CategoryCondition_Empty_Text: 'Geen categorie',
    CategoryCondition_Entity: 'categorieën',
    CategoryCondition_Text: 'Categorie',
    Clear_All_Text: 'Alle filters wissen',
    CompletedStatus_Text: 'Voltooid',
    constraints_filters_group: 'Beperkingen',
    ContainMore_Text: 'Er zijn meer resultaten, blijf typen...',
    CreationDate_Text: 'Aanmaakdatum',
    CustomerCondition_Empty_Text: 'Geen klant',
    CustomerCondition_Entity: 'klanten',
    CustomerCondition_Text: 'Klanten',
    CustomFieldsFilters_Group: 'Aangepaste velden',
    DraftCondition_Text: 'Concepten',
    DraftStatus_Text: 'Concepten',
    EndDate_Text: 'Einddatum',
    FilterByKeyword_Text: 'Filter op trefwoord',
    FilterByPeriod_Text: 'Filteren op periode',
    FilterByTimeframe_Text: 'Filteren op tijdsbestek',
    FilterTabs_Tab1: 'Statussen',
    FilterTabs_Tab2: 'Middelen & beperkingen',
    FilterTabs_Tab3: 'Gezondheid & voortgang',
    FilterTabs_Tab4: 'Projecten, klanten & meer',
    FilterTabs_Tab5: 'Aangepaste velden',
    Followed: 'Volgen',
    FollowedByMe_Text: 'Activiteiten die ik volg',
    From_Text: 'van',
    general: 'Algemeen',
    HealthCondition_Text: 'Gezondheid',
    HealthItemType_Bad: 'Probleem',
    HealthItemType_Good: 'Goed',
    HealthItemType_Medium: 'Risico',
    HealthItemType_NotCalculated: 'Niet berekend',
    HealthTooltip_Text: 'Gezondheid is een berekende index die aangeeft hoe goed een project of activiteit verloopt.',
    HealthTooltipLink_Text: 'Bekijk meer in onze online help',
    HoursCondition_Text: 'Tijd',
    HoursFilters_Group: 'Tijd',
    HoursLeft: 'Uren over',
    InProgressStatus_Text: 'In uitvoering',
    InThePast: 'In het verleden',
    InvalidDate: 'Datum moet in \'{0}\' formaat zijn.',
    Issue_Text: 'Probleem',
    KeepTyping_Text: 'Blijf typen...',
    ListCustomFieldCondition_Empty_Text: 'Niet geselecteerd',
    ManualRange: 'Opgegeven datumbereik...',
    Me: 'Ik',
    Menu_Dates: 'Datums',
    Milestone_Text: 'Mijlpaal',
    MoneyCondition_Text: 'Geld',
    More_Text: 'Meer',
    MultiSelectCustomFieldCondition_Empty_Text: 'Niet geselecteerd',
    NextMonth: 'Volgende maand',
    NextWeek: 'Volgende week',
    no_filters: 'Geen filters om weer te geven',
    NoCategory: 'Geen categorie',
    NoMatch_Text: 'Sorry, niets gevonden',
    OnHoldStatus_Text: 'In wachtstand',
    PeopleCondition_Text: 'Personen',
    PinTooltip_Text: 'Pin',
    Portfolio_Status_Text: 'Portefeuillestatus',
    PortfolioCondition_Empty_Text: 'Geen portefeuille geselecteerd',
    PortfolioCondition_Entity: 'portefeuilles',
    PortfolioCondition_Text: 'Portefeuilles',
    PortfolioCreator_Text: 'Makers van portefeuilles',
    PortfolioCreatorCondition_Text: 'Maker van portefeuilles',
    PortfolioManager_Text: 'Portefeuillemanagers',
    PortfolioManagerCondition_Text: 'Portefeuillemanager',
    PreviousMonth: 'Vorige maand',
    PreviousWeek: 'Vorige week',
    PreviousYear: 'Vorig jaar',
    PriorityCondition_Text: 'Prioriteiten',
    Progress_Filters_Group: 'Voortgang',
    ProgressCondition_Entity: 'Voortgang:',
    ProgressCondition_Text: 'Voortgang',
    Project_Text: 'Project',
    ProjectActualBilling: 'Project facturering',
    ProjectActualCompletionDateCondition_Text: 'Project daadwerkelijke voltooiingsdatum',
    ProjectActualCost: 'Project daadwerkelijke kosten',
    ProjectActualGreaterThanEstimated_Text: 'Onderschatte projecten',
    ProjectActualHours: 'Project daadwerkelijke uren',
    ProjectActualLaborBilling: 'Project facturering van daadwerkelijke arbeid',
    ProjectActualLaborCost: 'Project daadwerkelijke arbeidskosten',
    ProjectBillableHours: 'Project facturabele uren',
    ProjectBilled: 'Gefactureerde projecten',
    ProjectBilledLabor: 'Gefactureerde arbeid van projecten',
    ProjectBilledPercentage: 'Gefactureerde projecten, %',
    ProjectBudgetVariance: 'Afwijking in projectbudget',
    ProjectCondition_EmptyText: 'Geen project geselecteerd',
    ProjectCondition_Entity: 'projecten',
    ProjectCondition_Text: 'Projecten',
    ProjectCostExceedBudget_Text: 'Overbudgette projecten',
    ProjectCreationDateCondition_Text: 'Project aanmaakdatum',
    ProjectCreator_Text: 'Projectmakers',
    ProjectCreatorCondition_Text: 'Projectmaker',
    ProjectCustomFieldCondition_Text: 'Project aangepaste velden',
    ProjectDuration: 'Projectduur',
    ProjectEACBillableExpenses: 'Project EAC facturabele onkosten',
    ProjectEACBilling: 'Project EAC facturatie',
    ProjectEACCost: 'Project EAC kosten',
    ProjectEACExpenses: 'Project EAC onkosten',
    ProjectEACLaborBilling: 'Project EAC facturabele arbeid',
    ProjectEACLaborCost: 'Project EAC arbeidskosten',
    ProjectEACNonBillableExpenses: 'Project EAC niet-facturabele onkosten',
    ProjectEndDateCondition_Text: 'Project einddatum',
    ProjectEstimatedExpensesAmount: 'Project ETC onkosten',
    ProjectEstimatedExpensesBillableAmount: 'Project ETC facturabele onkosten',
    ProjectEstimatedExpensesNonBillableAmount: 'Project ETC niet-facturabele onkosten',
    ProjectEstimatedHours: 'Project geschatte uren',
    ProjectETCBilling: 'Project ETC facturatie',
    ProjectETCCost: 'Project ETC kosten',
    ProjectETCLaborBilling: 'Project ETC facturabele arbeid',
    ProjectETCLaborCost: 'Project ETC arbeidskosten',
    ProjectExpectedProfit: 'Verwachte winst van project',
    ProjectExpectedProfitPercentage: 'Verwachte winst van project, %',
    ProjectExpensesAmount: 'Project daadwerkelijke onkosten',
    ProjectExpensesBillableAmount: 'Project daadwerkelijke facturabele onkosten',
    ProjectExpensesBilledAmount: 'Gefactureerde onkosten van projecten',
    ProjectExpensesNonBillableAmount: 'Project daadwerkelijke niet-facturabele onkosten',
    ProjectHealthCondition_Text: 'Projectgezondheid',
    ProjectHealthTypes: 'Projectgezondheid',
    ProjectManager_Text: 'Projectmanagers',
    ProjectManagerCondition_Text: 'Projectmanager',
    ProjectMemberCondition_Text: 'Projectlid',
    ProjectNonBillableHours: 'Project niet-facturabele uren',
    ProjectPriorityCondition_Text: 'Projectprioriteit',
    ProjectPriorityCondition_Text_Template: 'Projecten met prioriteit %s',
    ProjectProcessCondition_Text: 'Projectvoortgang',
    ProjectProfit: 'Projectwinst',
    ProjectProfit_Text: 'Projecten met financieel verlies',
    ProjectProfitPercentage: 'Projectwinst, %',
    ProjectProgress_Text: 'Projectvoortgang',
    ProjectsAndTasksList_Title: 'Projecten en taken',
    ProjectsCustomersAndMore_Filters_Group: 'Projecten, klanten en meer',
    ProjectStartDateCondition_Text: 'Project startdatum',
    ProjectStatusCondition_Text: 'Projectstatus',
    ProjectTotalBudget: 'Totaal projectbudget',
    QuickFilterWatermark: 'Filteren op...',
    range_condition_text: 'Bereik',
    Request_Text: 'Verzoek',
    resource_types_condition_text: 'Middelen',
    resource_types_planning_condition_text: 'Projecten met middelen',
    resource_types_unnamed_label: 'Anonieme middelen',
    resource_types_user_label: 'Gebruikers',
    ResourceRequestApprover_Text: 'Goedkeurder van middelenverzoek',
    ResourceRequestCreator_Text: 'Maker van middelenverzoek',
    ResourceRequestStatuses_Approved: 'Goedgekeurd',
    ResourceRequestStatuses_Rejected: 'Afgewezen',
    ResourceRequestStatuses_WaitingForApproval: 'Wachtend op goedkeuring',
    ResourceRequestStatuses_WithoutRequest: 'Zonder verzoek',
    ResourceRequestStatusFilter_Text: 'Status van middelenverzoek',
    resources_filters_group: 'Middelen',
    resources_requests_filters_group: 'Middelenverzoeken',
    ResourcesAndConstraints_Filters_Group: 'Middelen en beperkingen',
    roles_condition_text: 'Rollen',
    RollBack_Text: 'Terug naar vorige filters',
    SaveFilters_Title: 'Opgeslagen filters',
    set_filters: 'Stel filters in met behulp van het',
    set_filters_part2: 'pictogram',
    skills_condition_text: 'Vaardigheden',
    StartDate_Text: 'Startdatum',
    Statuses_Filters_Group: 'Status',
    StatusesCountFormat: '1#{0} status#{0} statussen',
    Task_Text: 'Taak',
    TaskCondition_Entity: 'activiteiten',
    TaskCondition_Text: 'Activiteit',
    TaskCostExceedBudget_Text: 'Overbegrote activiteiten',
    TaskPriorityCondition_Entity: 'activiteitsprioriteiten',
    TaskPriorityCondition_Text: 'Activiteitsprioriteit',
    TaskPriorityCondition_Text_Template: 'Activiteiten met %s prioriteit',
    TasksAssignedToMilestone_Text: 'Activiteit toegewezen aan mijlpaal',
    teams_condition_text: 'Teams',
    TemplateCondition_Text: 'Sjablonen',
    TemplateStatus_Text: 'Sjablonen',
    ThisMonth: 'Deze maand',
    ThisWeek: 'Deze week',
    ThisYear: 'Dit jaar',
    To_Text: 'naar',
    Today: 'Vandaag',
    TypesCondition_Text: 'Typen',
    UnpinTooltip_Text: 'Losmaken',
    users_condition_text: 'Gebruikers',
    Yesterday: 'Gisteren',
};
